_ = require 'underscore'
f = require 'effing'
MemberOrgActivityView = require 'views/organization/member-org-activity-view'
OrganizationActionsComponent = require 'views/organization/organization-actions-component' # EXPERIMENT: teamMembersTabLayoutV2
{ OrganizationMembersAd } = require 'views/organization/organization-ad-component'
OrganizationChangeRolePopoverView = require 'views/member/organization-change-role-popover-view'
OrganizationMembersFilterListComponent = require 'views/organization/organization-members-filter-list-component'
OrganizationMembersItemComponent = require 'views/organization/organization-members-item-component'
OrganizationMembersListComponent = require 'views/organization/organization-members-list-component'
OrganizationMembersSidebarComponent = require 'views/organization/organization-members-sidebar-component'
RemoveOrDeactivateOrgMemberView = require 'views/organization/remove-or-deactivate-org-member-view'
React = require 'react'
ReactDOM = require 'react-dom'
ReactRootComponent = require 'views/internal/react-root-component'
recup = require 'recup'
simpleTest = require 'lib/experiments/simple-test'
t = require('views/internal/recup-with-helpers')('org_members')
track = require 'debug/track'
Util = require 'lib/util'
xtend = require 'xtend'
ClientConfig = require 'debug/client-config'

module.exports = class OrganizationMembersComponent extends React.Component
  constructor: (props) ->
    super
    @showNewLayout = simpleTest('teamMembersTabLayout')?.get('enabled')
    @state =
      filter: ''
      showAll: false
      # EXPERIMENT: teamMembersTabLayoutV2
      memberTypeFilter: 'team-member' # team-member, guest, enterprise
      # END EXPERIMENT: teamMembersTabLayoutV2

  render: t.renderable ->
    t.div '.org-members-page-layout', =>
      t.div '.org-members-page-layout-sidebar', =>
        t.addElement @orgSidebarPropsToElement()
        if !@props.sidebar.hasBC && !@props.sidebar.isAdDismissed && !ClientConfig.get('dontUpsell')
          t.addElement @orgAdComponent()
      t.div '.org-members-page-layout-list', =>
        # EXPERIMENT: teamMembersTabLayoutV2
        if @showNewLayout
          t.addElement @getOrganizationActionsElement()
        # END EXPERIMENT: teamMembersTabLayoutV2
        t.addElement @getMemberListElement()

  orgAdComponent: ->
    props =
      billingUrl: @props.sidebar.billingUrl
      dismissAd: @props.sidebar.dismissAd

    React.createElement OrganizationMembersAd, props

  orgSidebarPropsToElement: ->
    # EXPERIMENT: teamMembersTabLayoutV2
    if @showNewLayout
      teamTabProps = xtend @props.sidebar,
        orgIsEmpty: @props.orgIsEmpty
        orgMemberCount: @props.orgMemberModels.length
        guestMemberCount: @props.collaboratorModels.length
        memberTypeFilter: @state.memberTypeFilter
        onMemberTypeChange: (memberTypeFilter) =>
          @setState {
            memberTypeFilter
            filter: ''
          }
      return React.createElement OrganizationMembersFilterListComponent, teamTabProps
    # END EXPERIMENT: teamMembersTabLayoutV2
    props = xtend @props.sidebar,
      filter: @state.filter
      onFilterChange: (filter) =>
        @setState { filter }
      onShowAllChange: (showAll) =>
        @setState { showAll }

    React.createElement OrganizationMembersSidebarComponent, props

  getMemberListElement: ->
    # EXPERIMENT: teamMembersTabLayoutV2
    selectedItemsMap = {
      'guest': @props.collaboratorModels.map(f(@, 'memberModelToMemberItemElement'))
      'team-member': if @props.orgIsEmpty then [] else @props.orgMemberModels.map(f(@, 'memberModelToMemberItemElement'))

    }

    props =
      showNewLayout: @showNewLayout
      memberTypeFilter: @state.memberTypeFilter
      memberItems: if @showNewLayout then selectedItemsMap[@state.memberTypeFilter] else @props.orgMemberModels.map(f(@, 'memberModelToMemberItemElement'))

    React.createElement OrganizationMembersListComponent, props

  isVisibleMember: (member) ->
    (!member.hidden || @state.showAll) &&
    (!@state.filter || Util.buildFuzzyMatcher(@state.filter)(member.fullName))

  memberModelToMemberItemElement: (member) ->
    props = _.extend({ isFilterMatch: @isVisibleMember(member) }, member)

    React.createElement OrganizationMembersItemComponent, props

  # EXPERIMENT: teamMembersTabLayoutV2
  getOrganizationActionsElement: ->
    props = xtend @props.sidebar,
      orgId: @props.orgId
      orgMemberCount: @props.orgMemberModels.length
      orgIsEmpty: @props.orgIsEmpty
      guestMemberCount: @props.collaboratorModels.length
      isEnterpriseAdmin: @props.isEnterpriseAdmin
      memberTypeFilter: @state.memberTypeFilter
      hasBC: @props.sidebar.hasBC
      ownsOrg: @props.sidebar.ownsOrg
      orgName: @props.orgName
      orgIsPO: @props.orgIsPO
      filter: @state.filter
      onFilterChange: (filter) =>
        @setState { filter }
      onShowAllChange: (showAll) =>
        @setState { showAll }

    React.createElement OrganizationActionsComponent, props
  # END EXPERIMENT: teamMembersTabLayoutV2



// WEBPACK FOOTER //
// ./app/scripts/views/organization/organization-members-component.coffee